"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadIcon = void 0;
const styles_1 = require("@mui/material/styles");
const Download_1 = __importDefault(require("../icon/svgs/Download"));
exports.DownloadIcon = (0, styles_1.styled)(Download_1.default)(({ theme }) => ({
    width: "32px",
    height: "32px",
    minHeight: "32px",
    minWidth: "32px",
    "&, & path": {
        fill: theme.colours.inter
    },
    "&:hover": {
        cursor: "pointer"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Rvd25sb2FkLWRvY3VtZW50LWJ1dHRvbi9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLHFFQUE2QztBQUVoQyxRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxrQkFBUSxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQzNELEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxTQUFTLEVBQUUsTUFBTTtJQUNqQixRQUFRLEVBQUUsTUFBTTtJQUNoQixXQUFXLEVBQUU7UUFDWCxJQUFJLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0tBQzFCO0lBQ0QsU0FBUyxFQUFFO1FBQ1QsTUFBTSxFQUFFLFNBQVM7S0FDbEI7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9